import MetaPanel from '../../panels/meta'
import './index.css'

export default MetaPanel
